import $ from "jquery";

export default class Cart {
    constructor() {
        this.giftVariationsSelects = [
            ...document.querySelectorAll(".jsSelectVariations"),
        ];

        if (this.giftVariationsSelects.length) {
            this.events();
        }
    }

    events() {
        this.initializeSelectField();
    }

    initializeSelectField() {
        this.giftVariationsSelects.forEach((select) => {
            $(select).select2({
                placeholder: select.dataset.placeholderText,
                minimumResultsForSearch: -1,
            });
        });
    }
}
